
import Vue from "vue";
import AppPropsMixin from "@/components/mixins/AppPropsMixin.vue";
import axios from "axios";
import AuthBasic from "../data/authBasic";
import { HTTP_STATUS } from "../constants/HttpStatusCode";
import store from "../store";
import { UI_ENDPOINT } from "@/constants/EndPoints";
import BillingInfo from "./BillingInfo.vue";
import fieldEntryMixin from "@/components/mixins/fieldEntryMixin.vue";

// remove this and have code called the consolidated method from fieldEntryMixin.vue
function messageFormat(str: string, replacements: string[]) {
    return str.replace(/\{(\d+)\}/g, function() {
        return replacements[arguments[1]];
    });
};

export default Vue.extend({
  name: "payment-plan-signup",
  mixins: [fieldEntryMixin, AppPropsMixin],
  components: {BillingInfo},
  data: function() {
    return {
      isOpen: false,
      validPaymentPlanContactInfo: false,
      processingSignup: false,
      notSuccessfulYet: true
    };
  },
  props: {
    sapDocumentNumber: {
      type: Number, default: 0
    },
    outstandingBalance: {
      type: Number, default: 0
    }
  },
  created() {
    //@ts-ignore
    if (this.appProps.ppSignupConfirmationHTML.length < 1) {
      let url = UI_ENDPOINT.GET_PP_SIGNUP_CONFIRMATION_HTML;

      let that: any = this;
      axios
        .get(url, { auth: AuthBasic })
        .then(response => {
          that.appProps.ppSignupConfirmationHTML = response.data;
        })
        .catch(error => {})
        .finally(() => {});
    }
  },
  methods: {
    formatRequestFormVerbiage(requestFormVerbiage: string, formattedBalance: string, maximumMonths: string, formattedMinimumPayment: string, financeEmail: string): string {
      return messageFormat(requestFormVerbiage, [this.sapDocumentNumber.toString(), formattedBalance, maximumMonths, formattedMinimumPayment, financeEmail]);
    },
    getDateString() {
      const formatter = new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'long',
        day: '2-digit',
      });
      return formatter.format(new Date());
    },
    minimumPaymentAmount(): number {
      //@ts-ignore
      return this.ceilingRounding(this.outstandingBalance / this.appProps.paymentPlanMaximumMonths, 2);
    },
    attemptSignup() {
      //@ts-ignore
      let isValid = this.$refs.formPaymentPlanContactInfo.validate();
      if (!isValid) {
        return;
      }

      this.processingSignup = true;

      let url = UI_ENDPOINT.PAYMENT_PLAN_SIGNUP;
      let that: any = this;
      let success = false;

      //@ts-ignore
      let localBillingInfo = store.getters.billingModule.getBilling;

      axios
        .post(url, {
          //@ts-ignore
          sapDocumentNumber: store.getters.invoiceModule.getInvoicePayment.docNumber,
          name: localBillingInfo.firstName,
          email: localBillingInfo.email,
          phone: localBillingInfo.phone.toString().replace(/[() -]/g, ''),
          address1: localBillingInfo.address1,
          city: localBillingInfo.city,
          state: localBillingInfo.state,
          zipCode: localBillingInfo.zipCode,
          country: localBillingInfo.country
        }, { auth: AuthBasic })
        .then(response => {
          if (response.status == HTTP_STATUS.OK) {
            that.notSuccessfulYet = false;
            if (that.$el.querySelector('.paymentPlanRequestForm')) {
              that.$el.querySelector('.paymentPlanRequestForm').scrollTop = 0;
            }
          }
        })
        .catch(error => {
          // show the message mentioned in the response, or fallback to a generic message
          let msg = error.response && error.response.data ? error.response.data.message : 'An unexpected error occurred';
          alert(msg);
        })
        .finally(() => {
          that.processingSignup = false;
        });
    },
    close() {
      this.isOpen = false;
    }
  }
});
